module.exports = __webpack_public_path__ + "static/media/actuallySmallerOrcaGradSm.c9f11be1.png";